import { Dropdown, Form } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { FormError } from "../models/FormError";
import { DocumentType } from "../models/DocumentType";

export interface FormData {
  documentTypeIds: string[];
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  availableDocumentTypes?: DocumentType[];
}

const AddDocumentTypeToPermitTypeForm = ({ formData, onChange, formErrors, errors, availableDocumentTypes }: Props) => {
  const handleChange = (_: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Dropdown
            required
            error={formErrors.documentTypeIds}
            control={Dropdown}
            name="documentTypeIds"
            fluid
            label="Document types"
            placeholder="Select document types to add..."
            options={availableDocumentTypes?.map((d) => ({ key: d.id, text: d.name, value: d.id }))}
            value={formData.documentTypeIds ?? []}
            onChange={handleChange}
            multiple
            selection
            search
            noResultsMessage="All document types are already added to this permit type."
          />
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AddDocumentTypeToPermitTypeForm;
